import { isEmpty } from 'lodash';
import moment from 'moment';
import { TaskStatus } from '../../../interfaces/enums/TaskStatus';
import { FA, STATUS_FA_ALREADY_IN_PLACE, STATUS_FA_APPROVED } from '../../../constants';

export const FinancialAssistanceStatus = {
  Active: 1,
  Inactive: 0,
};

export const canFAWithFundingAvailableBeApproved = (tasks, financialAssistances, taskIds) => {
  const isRequestedTasks = Object.values(tasks).filter(
    faTask =>
      taskIds.some(v => v === faTask.id) && faTask.task_status_text === TaskStatus.Submitted,
  );

  const [fa] = Object.values(financialAssistances).filter(
    f => isRequestedTasks.some(v => v.id === f.task_fa_id) && f.zhi_program_id !== null,
  );
  if (fa !== undefined) {
    const requiredFieldsEmpty = isEmpty(fa.program_name) || fa.status === undefined;
    return !requiredFieldsEmpty && isRequestedTasks.length;
  }
  return true;
};

export const isFAExpired = fa => {
  const expirationDate = moment(fa.expiration_date);
  return moment().utc().isAfter(expirationDate);
};

export const checkFinancialAssistanceExists = (financialAssistances, currentForm) => {
  return Object.values(financialAssistances).some(
    x => x.task_fa_id === currentForm?.taskId && !isFAExpired(x),
  );
};

export const validateZHIProgramFields = (financialAssistances, currentForm, tasks, taskIds) => {
  const currentFinancialAssistance = Object.values(financialAssistances).find(
    x => x.task_fa_id === currentForm?.taskId,
  );

  const enableSaveForFa = canFAWithFundingAvailableBeApproved(tasks, financialAssistances, taskIds);

  return (
    enableSaveForFa &&
    !!currentFinancialAssistance.bin &&
    currentFinancialAssistance.group_id !== null &&
    currentFinancialAssistance.pcn !== null &&
    !!currentFinancialAssistance.member_id
  );
};

export const hasZHIProgram = (financialAssistances, currentForm) => {
  const currentFinancialAssistance = Object.values(financialAssistances).find(
    x => x.task_fa_id === currentForm?.taskId,
  );
  return !!currentFinancialAssistance && currentFinancialAssistance?.zhi_program_id !== null;
};

export const checkIfTransitionRequiresFAInformation = (faFormValues, taskIds) => {
  const nextTransition = status =>
    Object.values(faFormValues).filter(
      x => taskIds.some(v => x.taskId === v) && x.status_id === status,
    ).length > 0;

  return nextTransition(STATUS_FA_APPROVED);
};
